var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedPhotosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.6 33.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5f6368;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #636c75;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.28,
    y: 6.45,
    width: 21.99,
    height: 21.99,
    transform: "translate(11.24 -14.78) rotate(25.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.49,24.31c-.68-.32-1.16-.84-1.41-1.56-.26-.72-.23-1.42.1-2.1L31.38,3.22c.32-.68.84-1.16,1.56-1.41.72-.26,1.42-.23,2.1.1l17.43,8.21c.68.32,1.16.84,1.41,1.56s.23,1.42-.1,2.1l-8.21,17.43c-.32.68-.84,1.16-1.56,1.41-.72.26-1.42.23-2.1-.1l-17.43-8.21ZM25.66,21.82l17.43,8.21,8.21-17.43-17.43-8.21-8.21,17.43ZM25.66,21.82l8.21-17.43-8.21,17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.35,10.54l-5.57,10.36c-.14.27.07.58.37.55l10.57-.99c.27-.03.42-.32.3-.55l-5-9.37c-.14-.27-.52-.27-.67,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.72,
    y: 5.68,
    width: 21.99,
    height: 21.99,
    transform: "translate(-4.05 5.08) rotate(-16.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.98,31.28c-.73.21-1.42.14-2.09-.23-.67-.36-1.11-.91-1.32-1.64L1.12,10.93c-.21-.73-.14-1.42.23-2.09.36-.67.91-1.11,1.64-1.32L21.46,2.08c.73-.21,1.42-.14,2.09.23s1.11.91,1.32,1.64l5.44,18.48c.21.73.14,1.42-.23,2.09-.36.67-.91,1.11-1.64,1.32l-18.48,5.44ZM9.2,28.64l18.48-5.44-5.44-18.48L3.76,10.16l5.44,18.48ZM9.74,25.61l15.84-4.66-6.89-5.14-2.41,6.45-4.14-3.09-2.41,6.45ZM9.2,28.64L3.76,10.16l5.44,18.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedPhotosIcon);
export default __webpack_public_path__ + "static/media/advanced_photos_icon.8ebce29e3ee6aad5eed35173f987edf3.svg";
export { ForwardRef as ReactComponent };